import { render, staticRenderFns } from "./TipoDocumento.vue?vue&type=template&id=c5e55676&scoped=true"
import script from "./TipoDocumento.vue?vue&type=script&lang=js"
export * from "./TipoDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e55676",
  null
  
)

export default component.exports